// @flow

import type { Action } from './store.type';
import { CollectionsType } from 'src/models/filter-data';

export const GET_AVAILABLE_COLLECTIONS_REQUEST = 'GET_AVAILABLE_COLLECTIONS_REQUEST';
type GET_AVAILABLE_COLLECTIONS_REQUEST_TYPE = 'GET_AVAILABLE_COLLECTIONS_REQUEST';

export const GET_AVAILABLE_COLLECTIONS_SUCCESS = 'GET_AVAILABLE_COLLECTIONS_SUCCESS';
type GET_AVAILABLE_COLLECTIONS_SUCCESS_TYPE = 'GET_AVAILABLE_COLLECTIONS_SUCCESS';

export const GET_AVAILABLE_COLLECTIONS_FAILURE = 'GET_AVAILABLE_COLLECTIONS_FAILURE';
type GET_AVAILABLE_COLLECTIONS_FAILURE_TYPE = 'GET_AVAILABLE_COLLECTIONS_FAILURE';

export const GET_ALL_COLLECTIONS_REQUEST = 'GET_ALL_COLLECTIONS_REQUEST';
type GET_ALL_COLLECTIONS_REQUEST_TYPE = 'GET_ALL_COLLECTIONS_REQUEST';

export const GET_ALL_COLLECTIONS_SUCCESS = 'GET_ALL_COLLECTIONS_SUCCESS';
type GET_ALL_COLLECTIONS_SUCCESS_TYPE = 'GET_ALL_COLLECTIONS_SUCCESS';

export const GET_ALL_COLLECTIONS_FAILURE = 'GET_ALL_COLLECTIONS_FAILURE';
type GET_ALL_COLLECTIONS_FAILURE_TYPE = 'GET_ALL_COLLECTIONS_FAILURE';

type AvailableCollectionsSuccess = {
  data: CollectionsType
};

type AvailableCollectionsFailure = {
  error: any
};

type AllCollectionsSuccess = {
  data: CollectionsType
};

type AllCollectionsFailure = {
  error: any
};

type GetAvailableCollectionsRequestAction = Action<GET_AVAILABLE_COLLECTIONS_REQUEST_TYPE, null>;

type GetAvailableCollectionsSuccessAction = Action<
  GET_AVAILABLE_COLLECTIONS_SUCCESS_TYPE,
  AvailableCollectionsSuccess
>;

type GetAvailableCollectionsFailureAction = Action<
  GET_AVAILABLE_COLLECTIONS_FAILURE_TYPE,
  AvailableCollectionsFailure
>;

type GetAllCollectionsRequestAction = Action<GET_ALL_COLLECTIONS_REQUEST_TYPE, null>;

type GetAllCollectionsSuccessAction = Action<
  GET_ALL_COLLECTIONS_SUCCESS_TYPE,
  AllCollectionsSuccess
>;

type GetAllCollectionsFailureAction = Action<
  GET_ALL_COLLECTIONS_FAILURE_TYPE,
  AllCollectionsFailure
>;

export type AvailableCollectionsAction =
  | GetAvailableCollectionsRequestAction
  | GetAvailableCollectionsSuccessAction
  | GetAvailableCollectionsFailureAction;

export type AvailableCollectionsState = {
  loading: boolean,
  success: boolean,
  error: any,
  collections: CollectionsType | []
};

export type AllCollectionsAction =
  | GetAllCollectionsRequestAction
  | GetAllCollectionsSuccessAction
  | GetAllCollectionsFailureAction;

export type AllCollectionsState = {
  loading: boolean,
  success: boolean,
  error: any,
  collections: CollectionsType | []
};
